export enum VerticalAlignment {
  BOTTOM = "START",
  CENTER = "CENTER",
  TOP = "END",
}
